/* istanbul ignore file */
import { lazy, useMemo } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { UnicornApi } from '@cld/unicorn-api';

import { RemoteModule } from '../../components/remote-module/remote-module';
import { useMessage } from '../../i18n/useMessage';

type TacoModule = Awaited<typeof import('@cld-remote/taco/index')>;

const FixedWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
`;

const TacoApp = lazy(() =>
  import('@cld-remote/taco/index').then(({ Taco }: TacoModule) => ({
    default: Taco,
  }))
);

const ROLLBAR_ACCESS_TOKEN = '39575b31ed934c8a9d00ee98849fcc58';

export interface TacoProps {
  unicornApi: UnicornApi;
  shouldDisplayThumbnails?: boolean;
}

export const Taco = ({ unicornApi, shouldDisplayThumbnails }: TacoProps) => {
  const t = useMessage();

  // Create dedicated Rollbar error tracker
  const ErrorTracker = useMemo(() => unicornApi.methods.createLogger(ROLLBAR_ACCESS_TOKEN), [unicornApi.methods.createLogger]);

  return (
    <RemoteModule documentTitle={t('transformation-suite')}>
      {createPortal(
        <ErrorTracker.ErrorBoundary errorBoundaryLogLabel="Transformation Suite">
          <FixedWrapper>
            <TacoApp unicornApi={unicornApi} />
          </FixedWrapper>
        </ErrorTracker.ErrorBoundary>,
        document.body
      )}
    </RemoteModule>
  );
};
